import clsx from 'clsx';
import { ButtonHTMLAttributes, ReactNode } from 'react';

import MuiButton from '@material-ui/core/Button';

import styles from './Button.module.scss';

/**
 * NOTE - Please use this button from now for design consistency and accessibility.
 * Don't hesitate to modify this button since its currently only has one variant and few implementations.
 */

type ButtonTrackEvent = {
  'element type': 'button';
  'element text': string;
};

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  children: ReactNode;
  onClick?: () => void;
  href?: string;
  disabled?: boolean;
  iconLeft?: JSX.Element;
  iconRight?: JSX.Element;
  trackFunction: ((trackEvent: ButtonTrackEvent) => void) | null;
  className?: string;
  type?: 'button' | 'submit' | 'reset';
  variant?: 'outlined' | 'contained';
  // 'teal' is Button V3's teal with a navy label (CMS redesign); 'secondary' keeps its green label
  colorVariant?: 'primary' | 'secondary' | 'shade' | 'teal';
};

// TODO: spread the default props so they can actually be used when using this button - problems with some HTML button props messing with mui button props
export const Button = ({
  children,
  onClick,
  href = '',
  disabled,
  trackFunction,
  iconLeft,
  iconRight,
  className,
  type = 'button',
  variant = 'contained',
  colorVariant = 'primary',
}: ButtonProps) => (
  <div className={clsx(styles.container, className)}>
    <MuiButton
      className={clsx(
        styles.myButton,
        variant === 'contained' ? styles.contained : styles.outlined,
        colorVariant === 'secondary' && styles.secondary,
        colorVariant === 'shade' && styles.shade,
        colorVariant === 'teal' && styles.teal,
      )}
      variant={variant}
      href={href}
      type={type}
      disabled={disabled}
      onClick={() => {
        if (disabled) {
          return;
        }
        trackFunction?.({
          'element text': children?.toString() ?? '',
          'element type': 'button',
        });
        onClick?.();
      }}
      startIcon={iconLeft}
      endIcon={iconRight}
    >
      {children}
    </MuiButton>
  </div>
);

export default Button;
